import { render, staticRenderFns } from "./AdminTableActionButton.vue?vue&type=template&id=48f15ca4&scoped=true&"
import script from "./AdminTableActionButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../src/web/assets/admintable/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f15ca4",
  null
  
)

export default component.exports